import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Table, Tag } from 'antd';
import { AppstoreOutlined, RocketOutlined, DownloadOutlined, UserOutlined } from '@ant-design/icons';
import { dashboardService } from '../services/dashboard';
import dayjs from 'dayjs';

const Dashboard: React.FC = () => {
  const [data, setData] = useState<any>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const response: any = await dashboardService.getOverview();
      setData(response);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: '应用名称',
      dataIndex: ['application', 'name'],
      key: 'name',
    },
    {
      title: '版本号',
      dataIndex: 'versionNumber',
      key: 'version',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => {
        const colors: any = {
          Production: 'green',
          Beta: 'blue',
          Alpha: 'orange',
        };
        return <Tag color={colors[status]}>{status}</Tag>;
      },
    },
    {
      title: '发布时间',
      dataIndex: 'createdAt',
      key: 'date',
      render: (date: string) => dayjs(date).format('YYYY-MM-DD HH:mm'),
    },
  ];

  return (
    <div>
      <h1>概览</h1>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总应用数"
              value={data.totalApps || 0}
              prefix={<AppstoreOutlined />}
              suffix={
                <span style={{ fontSize: 14, color: '#666' }}>
                  {data.activeApps || 0} 个活跃中
                </span>
              }
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="总版本数"
              value={data.totalVersions || 0}
              prefix={<RocketOutlined />}
              suffix={
                <span style={{ fontSize: 14, color: '#666' }}>
                  覆盖 {data.totalApps || 0} 个应用
                </span>
              }
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="总下载次数"
              value={data.totalDownloads || 0}
              prefix={<DownloadOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="活跃用户"
              value={573}
              prefix={<UserOutlined />}
              suffix={<span style={{ fontSize: 14, color: '#666' }}>当前在线</span>}
            />
          </Card>
        </Col>
      </Row>

      <Card title="最近发布" style={{ marginTop: 24 }}>
        <Table
          columns={columns}
          dataSource={data.recentVersions || []}
          loading={loading}
          rowKey="id"
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Dashboard;
